module.exports = __webpack_public_path__ + "static/media/025.c734819e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/025.jpg
// module id = 532
// module chunks = 0